export default __webpack_public_path__ + "static/media/amir-yaakobi.eaad624d.png";